import { toast } from "react-toastify";

import {
  fetchCreatePartnerOfferRequest,
  fetchCreatePartnerOfferSuccess,
  fetchCreatePartnerOfferFailure,
} from "./reducer";

import { CREATE_PARTNER_OFFER } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const createPartnerOffer =
  (jsonObj, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchCreatePartnerOfferRequest());

    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        CREATE_PARTNER_OFFER,
        "POST",
        jsonObj
      );

      if (response?.error) {
        dispatch(fetchCreatePartnerOfferFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchCreatePartnerOfferSuccess(response));
        dispatch(setSuccessMessage(true));

        toast.success("Partner offer created successfully");

        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(fetchCreatePartnerOfferFailure("Something went wrong"));

      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
